import React, {useState, useEffect, useRef} from 'react'

/**
 * Custom interval that should
 * work similarly to setInterval
 */
function useInterval(callback, delay) {
  // Still not quite sure what useRef does
  const savedCallback = useRef();

  // Watch for callback change and set
  // saved callback to the passed variable
  useEffect(() => {
    savedCallback.current = callback;
  }, [callback]);

  // Watch for the delay
  // Set this to null to stop
  useEffect(() => {
    function tick() {
      savedCallback.current();
    }

    if (delay !== null) {
      let intervalId = setInterval(tick, delay);
      return () => clearInterval(intervalId);
    }
  }, [delay]);
}

export default function Pedals(props) {
  const [speedCheckDelay, setSpeedCheckDelay] = useState(null);
  const [brakePressed, setBrakePressed] = useState(false);
  const [gasPressed, setGasPressed] = useState(false);

  const targetSpeed = React.useRef(null)

  const onBrakeDown = e => { 
      setGasPressed(false)
      if (props.speed > 0){
        setBrakePressed(true)
        if (props.speed > 5){
          targetSpeed.current = props.speed - 5;
        } else {
          targetSpeed.current = 0
        }
        setSpeedCheckDelay(100)
        props.setSpeed(targetSpeed.current);
        props.checkPosition(true);
      }
    };
    const onBrakeUp = e => {
      setBrakePressed(false);
      setSpeedCheckDelay(null)
    };

  const onGasDown = e => {
    setBrakePressed(false)
    if(!props.door){
      setGasPressed(true);
      if (props.speed <= 65){
        targetSpeed.current = props.speed + 5;
      } else {
        targetSpeed.current = 70;
      }
      setSpeedCheckDelay(100);
      props.setSpeed(targetSpeed.current);
    }

  };
  const onGasUp = e => {
    setGasPressed(false);
    setSpeedCheckDelay(null)
  };

  // Watches the speed and how it is affected
  // by the pedals being pressed and held
  useInterval(() => {
    // If button is still pressed adjust Target Speed
    if (brakePressed){
      if (targetSpeed.current > 0) {
        targetSpeed.current -= 1; 
      } else {
        setBrakePressed(false)
        setSpeedCheckDelay(null);
      }
    } else if (gasPressed) {
      if (targetSpeed.current <= 70) {
        targetSpeed.current += 1;
      } else {
        setGasPressed(false)
        setSpeedCheckDelay(null);
      }
    }

    // set target speed to new target speed
    props.setSpeed(targetSpeed.current);


  }, speedCheckDelay);

  return (
    <div className={`Pedals ${props.class || ''}`}>
      <div className="pedal brake" onMouseDown={e => { onBrakeDown(e) }} onMouseUp={e => { onBrakeUp(e) }} />
      <div className="pedal gas" onMouseDown={e => { onGasDown(e) }} onMouseUp={e => { onGasUp(e) }} />
    </div>
  )
}